import { gql } from '@apollo/client';

export const SUBMIT_DEPOSIT_INSURANCE_UPLOAD = gql`
  mutation SubmitDepositInsuranceUpload(
    $periodStart: String!
    $periodEnd: String!
    $fileBase64: String!
    $fileName: String!
  ) {
    submitDepositInsuranceUpload(
      periodStart: $periodStart
      periodEnd: $periodEnd
      fileBase64: $fileBase64
      fileName: $fileName
    )
  }
`;
